import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import useUpdateActivityPopup from "./useUpdateActivityPopup";
import { useState } from "react";

const useUpdateActivityPopupWithExitConfirmation = ({
	$activity, isPast
}) => {
	const updateActivityPopup = useUpdateActivityPopup({
		$activity,
		isPast
	});
    const dialogConfirmExitWithoutSaving = useShowDialogAlert();
	const [mustConfirm, setMustConfirm] = useState(false);
	function togglePopupShow() {
		if (!updateActivityPopup.popup.value || !mustConfirm) {
			updateActivityPopup.popup.toggle();
			return;
		}
		dialogConfirmExitWithoutSaving.open();
	}
	return {
		...updateActivityPopup,
		popup: {
			...updateActivityPopup.popup,
			toggle: togglePopupShow
		},
		dialogConfirmExitWithoutSaving,
		mustConfirm: {
			value: mustConfirm,
			set: setMustConfirm
		}
	}
}	
	
export default useUpdateActivityPopupWithExitConfirmation;